<script lang="ts">
    interface Props {
        title?: string;
        href?: string;
    }

    let { title, href }: Props = $props();
</script>

<div class="reptile-tile-placeholder">
    <oc-link-v2>
        <a class="reptile-tile-placeholder__link" {href} {title}>{title}</a>
    </oc-link-v2>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-tile-placeholder {
        height: 600px;
        text-align: center;

        &__link {
            color: tokens.$oc-semantic-color-text-default;
        }
    }
</style>
